import $ from 'jquery'
import makeLightbox from '../../lightbox'

/**
 * @param  {string} mainContainer
 * @return {void}
 */
export default function (mainContainer) {
  const $r = $(mainContainer)

  $r.on('click', '.item-name', () => $r.find('.item-image').magnificPopup('open'))

  makeLightbox($r.find('.item-image'), {
    delegate: 'a',
    type: 'image',
    gallery: { enabled: false },
  })
}



// WEBPACK FOOTER //
// ./src/frontend/page-helpers/serving-center/index.js